const PROFILE = {
  GET_PROFILE_DETAILS: 'GET_PROFILE_DETAILS',
  GET_PROFILE_DETAILS_SUCCESS: 'GET_PROFILE_DETAILS_SUCCESS',
  GET_PROFILE_DETAILS_FAILURE: 'GET_PROFILE_DETAILS_FAILURE',
  UPDATE_PROFILE_DETAILS: 'UPDATE_PROFILE_DETAILS',
  UPDATE_PROFILE_DETAILS_SUCCESS: 'UPDATE_PROFILE_DETAILS_SUCCESS',
  UPDATE_PROFILE_DETAILS_FAILURE: 'UPDATE_PROFILE_DETAILS_FAILURE',
  UPDATE_FIELD_VALUE: 'UPDATE_FIELD_VALUE',
  UPDATE_ERROR: 'UPDATE_ERROR',
  DISPLAY_TOAST: 'DISPLAY_TOAST',
  DISPLAY_NATIVE_TOAST: 'DISPLAY_NATIVE_TOAST',
  RESET_VALUES: 'RESET_VALUES',
  GET_LANGUAGE_DETAILS: 'GET_LANGUAGE_DETAILS',
  GET_LANGUAGE_DETAILS_SUCCESS: 'GET_LANGUAGE_DETAILS_SUCCESS',
  GET_LANGUAGE_DETAILS_FAILURE: 'GET_LANGUAGE_DETAILS_FAILURE',
  GET_JOB_DETAILS: 'GET_JOB_DETAILS',
  GET_JOB_DETAILS_SUCCESS: 'GET_JOB_DETAILS_SUCCESS',
  GET_JOB_DETAILS_FAILURE: 'GET_JOB_DETAILS_FAILURE',
  GET_DEPARTMENT_DETAILS: 'GET_DEPARTMENT_DETAILS',
  GET_DEPARTMENT_DETAILS_SUCCESS: 'GET_DEPARTMENT_DETAILS_SUCCESS',
  GET_DEPARTMENT_DETAILS_FAILURE: 'GET_DEPARTMENT_DETAILS_FAILURE',
}

export { PROFILE };